import api from "./api/config";

export const cartService = {
  // Müşterinin sepetini getir
  getCustomerCart: async (customerId) => {
    if (!customerId) {
      throw new Error("Müşteri ID'si gereklidir.");
    }
    try {
      const params = { customerId };
      console.log("CartService: Sepet isteniyor, params:", params);
      // Token interceptor tarafından eklenecek
      const response = await api.get("/cart/getCustomerCart", { params });
      console.log("CartService: Sepet yanıtı:", response);

      // Yanıt yapısını kontrol edelim (Örnek: { status: 1, data: { items: [], total_amount: ... } })
      if (response && response.status === 1 && response.data) {
        // Sadece data objesini (items ve total_amount içeren) dönelim
        return response.data;
      } else {
        console.warn("Beklenmeyen sepet yanıtı yapısı:", response);
        return { items: [], total_amount: "0.00" }; // Hata veya beklenmeyen yanıtta boş sepet dön
      }
    } catch (error) {
      console.error("CartService Error fetching customer cart:", error);
      throw new Error("Sepet getirilirken bir hata oluştu.");
    }
  },

  // Sepete ürün ekle
  addToCart: async (customerId, dealerId, productId) => {
    if (!customerId || !dealerId || !productId) {
      throw new Error(
        "Sepete ekleme için Müşteri ID, Bayi ID ve Ürün ID gereklidir."
      );
    }
    try {
      const data = { customerId, dealerId, productId };
      console.log("CartService: Sepete ekleniyor, data:", data);
      // Token interceptor tarafından eklenecek
      const response = await api.post("/cart/addToCart", data);
      console.log("CartService: Sepete ekleme yanıtı:", response);

      // Başarılı yanıtı kontrol et (API'nin ne döndürdüğüne bağlı)
      if (response && response.status === 1) {
        return response.data || response; // Başarı mesajı veya güncel sepet dönebilir
      } else {
        console.warn("Beklenmeyen sepete ekleme yanıtı yapısı:", response);
        throw new Error(response?.message || "Ürün sepete eklenemedi.");
      }
    } catch (error) {
      console.error("CartService Error adding to cart:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Ürün sepete eklenirken bir hata oluştu.";
      throw new Error(errorMessage);
    }
  },

  // Sepetten ürün silme
  deleteFromCart: async (customerId, dealerId, productId) => {
    if (!customerId || !dealerId || !productId) {
      throw new Error(
        "Sepetten silme için Müşteri ID, Bayi ID ve Ürün ID gereklidir."
      );
    }
    try {
      const data = { customerId, dealerId, productId };
      console.log("CartService: Sepetten siliniyor, data:", data);
      
      const response = await api.post("/api/v3/cart/deleteFromCart", data);
      console.log("CartService: Sepetten silme yanıtı:", response);

      if (response && response.status === 1) {
        return response.data || response;
      } else {
        console.warn("Beklenmeyen sepetten silme yanıtı yapısı:", response);
        throw new Error(response?.message || "Ürün sepetten silinemedi.");
      }
    } catch (error) {
      console.error("CartService Error deleting from cart:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Ürün sepetten silinirken bir hata oluştu.";
      throw new Error(errorMessage);
    }
  },

  // Miktar güncelleme (opsiyonel - API'de varsa)
  updateCartItemQuantity: async (customerId, dealerId, productId, quantity) => {
    // Bu fonksiyon API'de mevcut değilse, önce silip sonra yeni miktar ile eklemek gerekebilir
    console.warn("updateCartItemQuantity: API'de miktar güncelleme endpoint'i yok gibi görünüyor.");
    // Geçici çözüm: Silip tekrar ekle
    try {
      await cartService.deleteFromCart(customerId, dealerId, productId);
      // quantity kadar ekle (API tek seferde miktar kabul etmiyorsa loop gerekebilir)
      for (let i = 0; i < quantity; i++) {
        await cartService.addToCart(customerId, dealerId, productId);
      }
      return true;
    } catch (error) {
      throw new Error("Miktar güncellenirken hata oluştu: " + error.message);
    }
  }
};

export default cartService;
